<form [formGroup]="languageForm" class="language-form" *ngIf="!isLoading && languageList">
    <mat-form-field floatLabel="never">
        <mat-label>{{ 'main.languageSelector.shortLabel' | translate }}</mat-label>
        <mat-select name="lang" formControlName="lang">
            <mat-option *ngFor="let language of languageList" [value]="language">
                {{ language.codeISO }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>
